import { YesObject } from '@yes.technology/react-toolkit'
import { useEffect } from 'react'
import { RelationFieldType } from '../types/object-view'

type Params = {
  fieldType: RelationFieldType
  isEditing: boolean
  isFetching: boolean
  unsavedObjects: YesObject[]
  yesObjects: YesObject[]
  edit: () => void
}

const useRelationClassCardAutoEditEffect = ({
  fieldType,
  isEditing,
  isFetching,
  unsavedObjects,
  yesObjects,
  edit
}: Params) => {
  useEffect(() => {
    if (
      fieldType === 'card' &&
      !isEditing &&
      !isFetching &&
      unsavedObjects.length &&
      unsavedObjects.some((unsavedObject) =>
        yesObjects.every(
          (savedObject) => savedObject.uuid !== unsavedObject.uuid
        )
      )
    ) {
      edit()
    }
  }, [
    edit,
    isEditing,
    unsavedObjects.length,
    fieldType,
    isFetching,
    unsavedObjects,
    yesObjects
  ])
}

export default useRelationClassCardAutoEditEffect
